export default {
  getSuggestions: (state) => state.suggest
};
